import { AbstractApiService } from '@api/service';
import { APIResponse, PaginationOptions, SortOptions } from '@api/types';
import { buildUrl } from '@api/utils';
import { createFormData } from '@common/utils/create-form-data';
import { createUrl } from '@common/utils/url';
import { ISurveyDocumentGroup } from '@legacy/types';
import { makeAsyncCall } from '../../../../../utils';
import { SurveyDocumentGroupServiceSaveDTO } from './SurveyDocumentGroupServiceSaveDTO';

export type SurveyDocumentGroupsGetRequestFilter = {
  survey_id?: number;
};

export type SurveyDocumentGroupsServiceGetParams = {
  filter: SurveyDocumentGroupsGetRequestFilter;
} & PaginationOptions
& SortOptions;

export class SurveyDocumentGroupsService extends AbstractApiService {
  /**
   * Saves a survey document group by sending a POST or PUT request to the backend.
   */
  async save(data: SurveyDocumentGroupServiceSaveDTO): Promise<ISurveyDocumentGroup> {
    const { preview_img_url, ...rest } = data;

    const response = await this.axios.post<{ data: ISurveyDocumentGroup }>(
      `/survey-document-groups${data.id ? `/${data.id}` : ''}?_method=${data.id ? 'PUT' : 'POST'}`,
      createFormData({
        ...rest,
        ...(preview_img_url === null ? { preview_path: null } : { preview: preview_img_url }),
      })
    );

    return response.data.data;
  }

  async get({
    sort,
    per_page,
    page,
    filter,
  }: SurveyDocumentGroupsServiceGetParams): Promise<ISurveyDocumentGroup[]> {
    const response: APIResponse<{ data: ISurveyDocumentGroup[] }> = await makeAsyncCall({
      url: createUrl('survey-document-groups', filter, sort, per_page, page, undefined),
      method: 'GET',
    });

    return response.body.data;
  }

  async getById(groupId: number): Promise<ISurveyDocumentGroup> {
    const response: APIResponse<{ data: ISurveyDocumentGroup }> = await makeAsyncCall({
      url: buildUrl(`survey-document-groups/${groupId}`),
      method: 'GET',
    });

    return response.body.data;
  }
}
